import { createSelector } from '@reduxjs/toolkit';
import {
  getFromImmutableState,
  getImmutableCompatible,
} from '../../../utils/immutableUtils';

export const getFilters = (state) => state.get('filters');
export const getPlainFilters = getFromImmutableState(getFilters);

const getMobileHotelFilter = createSelector(getFilters, (filters) =>
  getImmutableCompatible(filters, 'mobileHotelFilter'),
);

export const isMobileHotelFilterOpenedSelector = createSelector(
  getMobileHotelFilter,
  (mobileHotelFilter): boolean | undefined =>
    mobileHotelFilter?.get('isOpened'),
);

export const getFilter = (state, filterName) =>
  state.getIn(['filters', filterName]);
